import React, { useState, useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Table, TableBody, TableRow, TableCell, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, TableHead, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CloseIcon from '@mui/icons-material/Close';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import Obj2StrArr from './Obj2StrArr.js'
import safeAddress from './SafeAddress.js'

function Component(props) {
    const { UserUid, Debits, Means, UsersList, lastReceitpNumber, DbUpload, offlineMeansUpdate, offlineDebitsUpdate, DbBackup, DbBackupRestore } = props
    const [modDebit, setModDebit] = useState({});
    const [modDebitEnbled, setModDebitEnabled] = useState(false);
    const [newMean, setNewMean] = useState('');
    const [meanToDelete, setMeanToDelete] = useState(null);
    const [cutDate, setCutDate] = useState(Debits.cutDate ? Debits.cutDate.importe : 31 || 31);

//    console.log('UsersList', UsersList);

    const storeModDebit = () => {
        let debitDetail = {
            importe: Number(modDebit.importe),
            importeB: Number(modDebit.importeB) || null,
            nombre: modDebit.nombre,
            periodicidad: modDebit.periodicidad,
            timestamp: {
                seconds: Math.round(new Date() / 1000),
            },
            userId: UserUid,
        },
            uploadsArray = Obj2StrArr(debitDetail, `/debits/${modDebit.key}`) || {};
        DbUpload(uploadsArray).then(r => r && offlineDebitsUpdate())
        setModDebit({});
    }

    const debitDelete = key => {
        let d = {};
        d[`/debits/${key}`] = null;
        DbUpload(d).then(r => r && offlineDebitsUpdate());
    }

    const storeNewMean = () => {
        let d = {};
        d[`/means/${safeAddress(newMean)}`] = newMean;
        DbUpload(d).then(r => r && offlineMeansUpdate());
        setNewMean('');
    }

    const confirmMeanDelete = () => {
        let d = {};
        d[`/means/${meanToDelete}`] = null;
        DbUpload(d).then(r => r && offlineMeansUpdate());
        setMeanToDelete(null);
    }

    useEffect(() => {
        setModDebitEnabled(!!modDebit.key && !!modDebit.nombre && !!modDebit.importe && !!modDebit.periodicidad);
    }, [modDebit])

    const setcutDateVal = (val) => {
        if (val)
            val = Math.max(1, Math.min(31, Number(val)));
        setCutDate(val)
    }
    const storeCutDate = () =>
        DbUpload({ '/debits/cutDate/importe': cutDate }) && offlineDebitsUpdate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                m: 2,
            }}>
            <Accordion
                sx={{ '&.Mui-expanded .MuiAccordionSummary-content .hideOnExpand': { opacity: 0 } }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ fontSize: 18, fontWeight: 'bold' }}
                >
                    Débitos&nbsp;<span className="hideOnExpand">({Object.keys(Debits).filter(d => (!!Debits[d] && !!Debits[d].timestamp)).length})</span>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Concepto</TableCell>
                                <TableCell colSpan={2} sx={{ textAlign: 'center' }}>Importe</TableCell>
                                <TableCell>Per.</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.keys(Debits).filter(d => (!!Debits[d] && !!Debits[d].timestamp)).map(deb => {
                                if (!deb || !Debits[deb]) return '';

                                let dateData = Debits[deb].timestamp,
                                    [d, t] = ['', ''],
                                    date = '';

                                [d, t] = typeof dateData == 'object' ?
                                    new Date(Debits[deb].timestamp.seconds * 1000).toLocaleString().split(', ')
                                    :
                                    (typeof dateData == 'string' && dateData.length === 10) ?
                                        [dateData.split('-').toReversed().join('/'), '']
                                        :
                                        ['', '']

                                d = d.split('/').map(i => (i.length < 2 ? '0' : '') + i).join('/');
                                t = t === '00:00:00' ? '' : t.split(':').map(i => (i.length < 2 ? '0' : '') + i).join(':');
                                date = [d, t].join(' ');
                                return (
                                    <TableRow
                                        key={`debitsRow-${deb}`}
                                        onClick={() => setModDebit({ ...Debits[deb], key: deb })}
                                        sx={{
                                            '& .deleteButton': { transition: 'opacity .2s ease-in-out' },
                                            '&:not(:hover) .deleteButton': { opacity: 0 },
                                        }}
                                        title={`Actualizado ${date}`}
                                    >
                                        <TableCell sx={{ border: 'none' }}>{Debits[deb].nombre}</TableCell>
                                        <TableCell colSpan={1 + !Debits[deb].importeB} sx={{ border: 'none', textAlign: 'center' }}>$ {Debits[deb].importe || ''}</TableCell>
                                        {Debits[deb].importeB && (<TableCell sx={{ border: 'none', textAlign: 'center' }}>$ {Debits[deb].importeB || ''}</TableCell>)}
                                        <TableCell sx={{ border: 'none', fontSize: '10px' }}>{Debits[deb].periodicidad || ''}</TableCell>
                                        <TableCell
                                            sx={{ border: 'none', fontSize: '10px', p: 0, textAlign: 'center' }}
                                            className="deleteButton"
                                        >
                                            <IconButton
                                                sx={{
                                                    p: 0,
                                                    m: 0,
                                                }}
                                                aria-label="delete"
                                                onClick={() => debitDelete(deb)}
                                            >
                                                <DeleteForeverIcon color="error" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 1,
                            alignItems: 'center'
                        }}>
                        Fecha de corte:
                        <TextField
                            id={`cutDateInput`}
                            variant="standard"
                            value={cutDate || ''}
                            onChange={(e) => setcutDateVal(e.target.value)}
                            type={'number'}
                            min={1}
                            max={31}
                            sx={{
                                fontSize: '1em',
                                width: '2em',
                                '& input': { appearance: 'none', textAlign: 'center' },
                                '& input::-webkit-outer-spin-button': {
                                    appearance: 'none',
                                    margin: 0,
                                },
                                '& input::-webkit-inner-spin-button': {
                                    appearance: 'none',
                                    margin: 0,
                                },
                            }}
                        />
                        <IconButton
                            aria-label="save"
                            disabled={cutDate === Debits.cutDate.importe}
                            onClick={storeCutDate}
                        >
                            <CloudUploadIcon color={cutDate !== Debits.cutDate.importe ? 'success' : 'disabled'} />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{ px: 1, pb: 0, pt: 2, fontSize: 16, fontWeight: 'bold' }}
                    >
                        Agregar / Editar Debito
                    </Box>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '5fr 2fr 2fr 3fr 2fr',
                            alignItems: 'center',
                            gap: 1,
                            width: '500px',
                            maxWidth: '90dvw',
                        }}
                    >
                        <TextField
                            id={`modDebitConcept`}
                            variant="standard"
                            value={modDebit.nombre || ''}
                            onChange={(e) => setModDebit({ ...modDebit, nombre: e.target.value, key: safeAddress(e.target.value) })}
                            placeholder={'Concepto'}
                            type={'text'}
                            sx={{ input: { px: 1 } }}
                        />
                        <TextField
                            id={`modDebitAmount`}
                            variant="standard"
                            value={modDebit.importe || ''}
                            onChange={(e) => setModDebit({ ...modDebit, importe: e.target.value })}
                            placeholder={'Imp. A'}
                            type={'number'}
                            sx={{
                                '& input': { appearance: 'none', textAlign: 'center' },
                                '& input::-webkit-outer-spin-button': {
                                    appearance: 'none',
                                    margin: 0,
                                },
                                '& input::-webkit-inner-spin-button': {
                                    appearance: 'none',
                                    margin: 0,
                                },
                            }}
                        />
                        <TextField
                            id={`modDebitAmountB`}
                            variant="standard"
                            value={modDebit.importeB || ''}
                            onChange={(e) => setModDebit({ ...modDebit, importeB: e.target.value })}
                            placeholder={'Imp. B'}
                            type={'number'}
                            sx={{
                                '& input': { appearance: 'none', textAlign: 'center' },
                                '& input::-webkit-outer-spin-button': {
                                    appearance: 'none',
                                    margin: 0,
                                },
                                '& input::-webkit-inner-spin-button': {
                                    appearance: 'none',
                                    margin: 0,
                                },
                            }}
                        />
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="modDebitPeriod-label">Period.</InputLabel>
                            <Select
                                labelId="modDebitPeriod-label"
                                id="modDebitPeriod"
                                value={modDebit.periodicidad || ''}
                                onChange={(e) => setModDebit({ ...modDebit, periodicidad: e.target.value })}
                                label="Period."
                                sx={{ fontSize: '1em', mb: 2 }}
                            >
                                <MenuItem key={'Mensual/Familiar'} value={'Mensual/Familiar'} sx={{ fontSize: '.85em' }}>Mensual/Familiar</MenuItem>
                                <MenuItem key={'Anual'} value={'Anual'} sx={{ fontSize: '.85em' }}>Anual</MenuItem>
                                <MenuItem key={'Mensual'} value={'Mensual'} sx={{ fontSize: '.85em' }}>Mensual</MenuItem>
                            </Select>
                        </FormControl>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 1,
                                justifyContent: 'space-evenly'
                            }}>
                            <IconButton
                                aria-label="save"
                                disabled={!modDebitEnbled}
                                onClick={storeModDebit}
                            >
                                <CloudUploadIcon color={!!modDebitEnbled ? 'success' : 'disabled'} />
                            </IconButton>
                            <IconButton
                                aria-label="delete"
                                onClick={() => setModDebit({})}
                            >
                                <CloseIcon color={(modDebit.periodicidad || modDebit.importe || modDebit.nombre) ? 'error' : 'disabled'} />
                            </IconButton>
                        </Box>
                    </Box>
                </AccordionDetails>
            </Accordion >

            <Box
                sx={{ fontSize: 18, }}
            >
                Último recibo emitido: <strong>{lastReceitpNumber}</strong>
            </Box>

            <Accordion
                sx={{ '&.Mui-expanded .MuiAccordionSummary-content .hideOnExpand': { opacity: 0 } }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ fontSize: 18, fontWeight: 'bold' }}
                >
                    Medios de pago&nbsp;<span className="hideOnExpand">({Means.filter(m => !!m).length})</span>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0 }}>
                    <Table size="small">
                        <TableBody>
                            {Means.map(mean => {
                                return mean ? (
                                    <TableRow
                                        key={`meansRow-${safeAddress(mean)}`}
                                        sx={{
                                            '& .deleteButton': { transition: 'opacity .2s ease-in-out' },
                                            '&:not(:hover) .deleteButton': { opacity: 0 },
                                        }}
                                    >
                                        <TableCell sx={{ py: 0, border: 'none' }}>{mean}</TableCell>
                                        <TableCell sx={{ p: 0, border: 'none' }} className="deleteButton">
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => setMeanToDelete(mean)}
                                            >
                                                <DeleteForeverIcon color="error" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ) : ''
                            })}
                            <TableRow>
                                <TableCell
                                    sx={{ pb: 0, px: 1, border: 'none' }}
                                >
                                    <TextField
                                        id={`newMean`}
                                        variant="standard"
                                        value={newMean || ''}
                                        onChange={(e) => setNewMean(e.target.value)}
                                        placeholder={'Nuevo Medio de Pago'}
                                        type={'text'}
                                        sx={{
                                            width: '100%',
                                            input: {
                                                px: 1,
                                            }
                                        }}
                                    />
                                </TableCell>
                                <TableCell
                                    sx={{ pb: 0, px: 0, border: 'none' }}
                                >
                                    <IconButton
                                        aria-label="save"
                                        disabled={!newMean}
                                        onClick={storeNewMean}
                                    >
                                        <CloudUploadIcon color={!!newMean ? 'success' : 'disabled'} />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ fontSize: 18, fontWeight: 'bold' }}
                >
                    Usuarios
                </AccordionSummary>
                <AccordionDetails

                >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Nombre</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>UID</TableCell>
                                <TableCell>Permisos</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {UsersList.map(user => (
                                <TableRow
                                    key={`usersRow-${user.uid}`}
                                >
                                    <TableCell sx={{ border: 'none' }}>{user.nombre}</TableCell>
                                    <TableCell sx={{ border: 'none' }}>{user.email}</TableCell>
                                    <TableCell sx={{ border: 'none' }}>{user.uid}</TableCell>
                                    <TableCell sx={{ border: 'none' }}>{UserUid === user.uid ? ({ admin: 'Administrador', socio: 'Socio' }[user.categoria] || '') : (
                                        <FormControl variant="standard" fullWidth>
                                            <Select
                                                sx={{ fontSize: '.95em' }}
                                                id={`userCategorySelector-${user.uid}`}
                                                value={user.categoria || ''}
                                                onChange={(e) => { let c = {}; c[`/users/${user.uid}/categoria`] = e.target.value; DbUpload(c) }}
                                            >
                                                <MenuItem key={'admin'} value={'admin'} sx={{ fontSize: '.85em' }}>Administrador</MenuItem>
                                                <MenuItem key={'socio'} value={'socio'} sx={{ fontSize: '.85em' }}>Socio</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}</TableCell>
                                </TableRow>))}
                        </TableBody>
                    </Table>




                </AccordionDetails>
            </Accordion>

            <Box
                sx={{
                    mt: 2,
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'start', md: 'center' },
                    justifyContent: 'space-evenly',
                    width: '100%',
                    gap: 1,
                }}
            >
                <Button
                    variant="outlined"
                    color="black"
                    onClick={DbBackup}
                    startIcon={<SaveAltIcon />}>
                    Backup Base de Datos
                </Button>

                <Button
                    sx={{ opacity: (window.location.hash.split('?')[1] || '').toLowerCase() !== 'enabledbupload' ? 0 : 1 }}
                    variant="outlined"
                    color="black"
                    onClick={DbBackupRestore}
                    startIcon={<UploadFileIcon />}>
                    Restaurar Base de Datos
                </Button>
            </Box>

            <Dialog
                open={Boolean(meanToDelete)}
                onClose={() => setMeanToDelete(null)}
            >
                <DialogTitle>
                    Eliminar Medio de Pago
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        ¿Confirma que desea eliminar el Medio de Pago "{Means && meanToDelete ? Means[meanToDelete] : ''}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setMeanToDelete(null)}>Cancelar</Button>
                    <Button onClick={confirmMeanDelete} autoFocus color="error">Eliminar</Button>
                </DialogActions>
            </Dialog>
        </Box >
    )
}

export default Component;